export default {
  zoomToFit: 'Zoom auto',
  arrangeNodes: 'Anordnen',
  zoomIn: 'Herein zoomen',
  zoomOut: 'Heraus zoomen',
  more: 'Weitere Funktionen',
  backgroundContextMenu: {
    addNode: {
      title: 'Einfügen',
      emitter: 'Quelle',
      function: 'Funktion',
      operator: 'Operator',
      variable: 'Variable',
    },
    preview: {
      title: 'Vorschau',
      hideAll: 'Alle deaktivieren',
    },
  },
};
